import FilterCheckbox from "./FilterCheckbox";
import {guardFieldCheckboxListType, guardFieldCheckboxType, guardFieldRangeType} from "../../../model/filter-types";
import FilterCheckboxList from "./FilterCheckboxList";
import FilterRange from "./FilterRange";
import React from "react";
import {FilterSelectorsUnionType} from "../../../model/types";
import {OnChangeFilterHandler} from "../../../model/useFilterHandler";

interface FilterRendererProps {
    keyField: string;
    field: FilterSelectorsUnionType;
    filedState: string | number | string[] | number[]; // конкретное значение одного фильтра
    onChangeHandler: OnChangeFilterHandler;
}
/**
 * Компонент-агрегатор, который отвечает за отображение конкретного UI-фильтра
 * на основе типа фильтра. Абстрагирует от родителя логику рендера.
 *
 * Поддерживает следующие типы:
 * - FilterFieldTypeEnum.checkbox — одиночный чекбокс
 * - FilterFieldTypeEnum.checkbox_list — список чекбоксов (dropdown)
 * - FilterFieldTypeEnum.range — слайдер диапазона значений
 *
 * @param keyField - Ключ поля фильтра
 * @param field - Конфигурация фильтра, включая тип и данные
 * @param filedState - Текущее значение фильтра (одно значение или массив)
 * @param onChangeHandler - Универсальный обработчик изменения значения
 *
 * @returns JSX.Element или null, если фильтр не поддерживается
 */
const FilterRenderer: React.FC<FilterRendererProps> = ({keyField, field, filedState, onChangeHandler}) => {
    if (!field || !keyField) return null;

    if (guardFieldCheckboxType(field)) {
        return (
            <FilterCheckbox
                keyField={keyField}
                field={field}
                filedState={Array.isArray(filedState) ? filedState: []}
                onChangeHandler={onChangeHandler}
            />
        );
    }

    if (guardFieldCheckboxListType(field)) {
        return (
            <FilterCheckboxList
                keyField={keyField}
                field={field}
                filedState={Array.isArray(filedState) ? filedState: []}
                onChangeHandler={onChangeHandler}
            />
        );
    }

    if (guardFieldRangeType(field)) {
        return (
            <FilterRange
                keyField={keyField}
                field={field}
                filedState={Array.isArray(filedState) ? filedState: []}
                onChangeHandler={onChangeHandler}
            />
        );
    }

    return null;
};

export default FilterRenderer;


